import React, {Fragment} from 'react'
import {Grid, Grow, Typography} from '@material-ui/core'
import {Field, useFormikContext} from 'formik'
import {CheckboxWithLabel} from 'formik-material-ui'
import {DatePickerField} from '../../../../components/DatePickerField'

import SelectField from '../../../../components/SelectField'
import {StepHeader} from '../../styles'

const Step9 = () => {
  const {
    values: { isPep },
  } = useFormikContext()
  return (
    <Fragment>
      <Grow mountOnEnter in timeout={500}>
        <StepHeader>
          <Typography
            variant="body1"
            gutterBottom
            color="textPrimary">
            Passo 2 de 3
          </Typography>
          <Typography
            variant="h5"
            gutterBottom
            color="textPrimary">
            Dados do representante
          </Typography>
        </StepHeader>
      </Grow>
      <Grow mountOnEnter in timeout={900}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Field
              Label={{ label: 'Pessoa políticamente exposta' }}
              color="primary"
              label="Pessoa políticamente exposta?"
              name="isPep"
              type="checkbox"
              component={CheckboxWithLabel}
            />
          </Grid>
          {isPep && (
            <Grid item xs={12}>
              <Field
                type="tel"
                fullWidth
                name="isPepSince"
                component={DatePickerField}
                label="Desde quando?"
                helperText="Vai que a gente manda um presente, né?"
              />
            </Grid>
          )}
          <Grid item xs={6}>
            <Field
              label="Estado civil"
              native
              name="maritalStatus"
              component={SelectField}
            >
              <option aria-label="None" value="" />
              <option value={1}>Solteiro</option>
              <option value={2}>Casado</option>
              <option value={3}>Legalmente separado</option>
              <option value={4}>Viúvo</option>
              <option value={5}>Divorciado</option>
              <option value={6}>União estável</option>
              <option value={7}>Separado</option>
            </Field>
          </Grid>
          <Grid item xs={6}>
            <Field
              label="Gênero"
              native
              name="gender"
              component={SelectField}
            >
              <option aria-label="None" value="" />
              <option value="M">Masculino</option>
              <option value="F">Feminino</option>
              <option value="O">Outros</option>
              <option value="N">Não desejo informar</option>
            </Field>
          </Grid>
        </Grid>
      </Grow>
    </Fragment>
  )
}

export default Step9
